import Icon from '@/components/Icon'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'next/router'
import { useState } from 'react'
import styles from './search.module.scss'

export default function Search({ alwaysOpen = false, searchQuery = '', hasResults = false, className = '' }) {
  const [isOpen, setIsOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const router = useRouter()
  const inputVisible = alwaysOpen || isOpen

  const placeholder = alwaysOpen && hasResults && searchQuery ? `${searchQuery}` : 'Search'

  const goToSearch = () => {
    const cleaned = searchTerm.trim()
    if (!cleaned) return
    if (router.pathname === '/search' && router.query.q === cleaned) return
    router.push(`/search?q=${encodeURIComponent(cleaned)}`)
    setSearchTerm('')
    if (!alwaysOpen) {
      setIsOpen(false)
    }
  }

  const toggleSearch = () => {
    if (!isOpen) {
      setIsOpen(true)
      return
    }

    if (alwaysOpen) {
      const cleaned = searchTerm.trim()
      if (cleaned) {
        goToSearch()
      } else {
        setSearchTerm('')
        setIsOpen(false)
      }
    } else {
      setSearchTerm('')
      setIsOpen(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      goToSearch()
    }
  }

  return (
    <div
      className={`${styles.searchContainer} ${alwaysOpen ? styles.alwaysOpen : styles.searchToggle} ${isOpen ? styles.openContainer : ''} ${className}`}
    >
      <div className={styles.inputWrapper}>
        <input
          type="text"
          className={`${styles.searchInput} ${isOpen ? styles.open : ''}  ${alwaysOpen ? styles.alwaysOpenInput : ''}`}
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            opacity: inputVisible ? 1 : 0,
            visibility: inputVisible ? 'visible' : 'hidden'
          }}
        />

        <button
          type="button"
          className={styles.iconButton}
          onClick={alwaysOpen ? goToSearch : toggleSearch}
          aria-label={alwaysOpen ? 'Search' : 'Toggle search'}
        >
          <Icon icon={faMagnifyingGlass} />
        </button>
      </div>
    </div>
  )
}
